import Link from "next/link";
import React from "react";
import Button from "../buttons/Button";
import Header from "../header/Header";

const ProBenefitsCard = () => {
  return (
    <div className="p-4 bg-white rounded shadow-xl dark:bg-theme-dark-light dark:shadow-none">
      <Header as="h4" className="mb-2 text-primary">
        Beneficios de ser ProDev
      </Header>

      <div className="flex flex-col space-y-4 text-sm">
        <p>
          Mejora tu experiencia, lleva a otro nivel tu aprendizaje y ten acceso
          a recursos exclusivos para destacar como programador.
        </p>

        <p>¿Te lo vas a perder?</p>
      </div>

      <Link href="/comprar/membresia">
        <Button type="primary" size="sm" className="mt-4" block>
          Ver Beneficios
        </Button>
      </Link>
    </div>
  );
};

export default ProBenefitsCard;
